<template>
  <div class="vx-col w-12/12">
    <div class="vx-row mb-6">
      <div class="flex flex-start ml-5" style="width: 50%">
        <v-select
          style="width: 100px"
          :options="limits"
          :clearable="false"
          @input="handleChangelength"
          v-model="params.length"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
      </div>
      <div class="mr-auto"></div>
      <div class="flex flex-end">
        <div class="flex flex-end">
          <vs-input
            class="mb-4 md:mb-0 mr-4 round"
            v-model="params.search"
            @keyup="handleSearch"
            placeholder="Search..."
          />
        </div>
      </div>
    </div>
    <vs-table
      @selected="handleSelected"
      :stripe="propsParams.stripe"
      bordered
      :sst="true"
      :data="data"
      @sort="handleSort"
    >
      <template slot="thead">
        <slot name="thead"></slot>
        <template v-for="(dataTh, index) in header">
          <vs-th
            v-if="dataTh.sortable != false"
            v-bind:key="index"
            :sort-key="dataTh.value"
            :width="dataTh.width"
          >
            {{ dataTh.text }}
          </vs-th>
          <vs-th v-else v-bind:key="index" :width="dataTh.width">
            {{ dataTh.text }}
          </vs-th>
        </template>
      </template>
      <tbody>
      <slot name="tbody"></slot>
      </tbody>
    </vs-table>
    <div class="vx-row mb-6">
      <div class="flex flex-start ml-5" style="font-size: 14px">
        {{ this.start }} - {{ this.end }} of {{ this.total }}
      </div>
      <div class="mx-auto"></div>
      <div class="flex flex-end">
        <vs-pagination
          style="padding-top: 5px"
          :total="totalPage"
          v-model="setPage"
          :prev-icon="$vs.rtl ? 'arrow_forward' : 'arrow_back'"
          :next-icon="$vs.rtl ? 'arrow_back' : 'arrow_forward'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import debounce from "debounce";

export default {
  components: {
    vSelect,
  },
  props: {
    responseData: Object,
    propsParams: Object,
    header: Array,
    stripe: {
      type: Boolean,
      default: true,
    },
    limits: {
      type: Array,
      default: () => {
        return [5, 10, 25, 50, 100];
      },
    },
  },
  watch: {
    responseData: function () {
      this.prosesResponse();
    },
  },
  mounted() {
    // console.log("datatable");
    this.checkboxHead = this.checkIfTheadHasCheckbox();
    // console.log(this.checkboxHead, "this.checkboxHead");
    this.data = [];
    this.params.length = this.propsParams.length;
    this.params.order = this.propsParams.order;
    this.params.sort = this.propsParams.sort;
    this.params.counting = this.propsParams.counting;
    this.prosesResponse();
  },
  data() {
    return {
      params: {
        search: "",
        length: 5,
        page: 1,
        order: "",
        sort: "",
        counting: 0,
      },
      total: 0,
      totalPage: 0,
      start: 1,
      end: this.length,
      data: [],
      debounceFunction: null,
      checkboxHead: false,
    };
  },
  methods: {
    handleSearch(searching) {
      this.search = searching;
      this.page = 1;
      this.$emit('search', this.params);
    },
    handleChangePage(page) {
      this.params.page = page;
      this.params.counting++;
      this.$emit('update:params', { ...this.params });
    },
    prosesResponse() {
      if (this.responseData.length > 0) {
        this.data = ["a", "a"];
      } else {
        this.data = [];
      }
      this.total = this.responseData.recordsTotal;
      if (this.responseData.recordsTotal >= 1) {
        // console.log("masuk else");
        this.totalPage = Math.ceil(this.total / this.params.length);
        this.setStartEnd();
      } else {
        // console.log("masuk if");
        this.totalPage = 0;
        this.start = 0;
        this.end = 0;
      }
    },
    handleSort(key, active) {
      if (this.checkboxHead && key === null) return;

      this.params.order = active;
      if (key !== null) {
        this.params.sort = key;
        this.params.page = 1;
        this.params.counting++;
        this.$emit('update:params', { ...this.params });
      }
    },
    handleChangelength(val) {
      this.params.length = val === "All" ? this.total : val;
      this.params.page = 1;
      this.params.counting++;
      this.$emit('update:params', { ...this.params });
    },
    getData(byPassDebounce = true) {
      if (byPassDebounce) {
        this.$emit("reloadDataFromChild", this.params);
        return;
      }

      if (this.debounceFunction) {
        this.debounceFunction.clear();
      }

      this.debounceFunction = debounce(() => {
        this.$emit("reloadDataFromChild", this.params);
      }, 700);

      this.debounceFunction();
    },
    handleSelected(tr) {
      this.$emit("selectedDataFromChild", tr);
    },
    setStartEnd() {
      let valStart =
        this.params.page * this.params.length - this.params.length + 1;
      if (valStart > this.total) {
        valStart = 1;
      }
      if (this.responseData.length == 0) {
        valStart = 0;
      }
      let valEnd = 0;
      if (this.total != 0) {
        valEnd =
          this.params.length * this.params.page -
          (this.params.length - this.responseData.length);
        if (valEnd > this.total) {
          valEnd = this.total;
        }
      } else {
        valStart = 0;
      }
      this.start = valStart;
      this.end = valEnd;
    },
    checkIfTheadHasCheckbox() {
      if (this.$slots.thead) {
        const slotNodes = this.$slots.thead;

        for (let node of slotNodes) {
          if (!node.componentOptions || !node.componentOptions.tag) {
            continue;
          }

          if (node.componentOptions.tag === "vs-th") {
            for (let child of node.componentOptions.children) {
              if (child.componentOptions.tag === "vs-checkbox") {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
  },
  computed: {
    setPage: {
      get() {
        return this.params.page;
      },
      set(val) {
        console.log("setPage", this.propsParams.counting)
        this.handleChangePage(val);
      },
    },
  },
};
</script>
